import { type SelectOption } from '../../../../../components';
import { PAGE_TEXT } from '../lang';
import { ACTIVITY_TYPE } from '../constants';

// The activity type options: community service, culture activity, sport, others
const activityTypeText =
  PAGE_TEXT.OTHER_INFORMATION.EXTRA_ACTIVITY.ACTIVITY_TYPE_OPTIONS;
const activityTypeKeys: string[] = Object.keys(activityTypeText);

export const activityTypeOptions: SelectOption[] = Object.values(
  activityTypeText,
).map((label: string, index: number) => ({
  value: ACTIVITY_TYPE[activityTypeKeys[index] as keyof typeof ACTIVITY_TYPE],
  label,
}));
